// @ts-nocheck

import { createSelector } from 'reselect';

import { selectEntitiesBetslipsEntity } from '../../../../selectors/entities/betslips/entitiesBetslipsPrimary.selector';

const selectBetslipHistoryGRData = createSelector(selectEntitiesBetslipsEntity, (betslip) => betslip?.data?.GR);

const selectBetslipHistoryGRDisabled = createSelector(selectBetslipHistoryGRData, (gr) => gr?.disabled);

const selectBetslipHistoryGRId = createSelector(selectBetslipHistoryGRData, (gr) => gr?.raceId);

const selectBetslipHistoryGRSkinId = createSelector(selectBetslipHistoryGRData, (gr) => gr?.skinId);

const selectGRBetslipHeadbandProps = createSelector(
  [selectBetslipHistoryGRDisabled, selectBetslipHistoryGRId, selectBetslipHistoryGRSkinId],
  (isDisabled, race, skinId) => ({
    skinId,
    isDisabled,
    isVisible: !!race,
  }),
);

export default selectGRBetslipHeadbandProps;
